export default __webpack_public_path__ + "static/media/vip_okara.12612a28.svg";